import { FC } from "react";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { CoverImage } from "@/components";
import Image from "@/assets/cover/news_dbg.webp";

const GamePassPage: FC = (): JSX.Element => {
  // Page Document Title
  useDocumentTitle("Game Pass");

  return (
    <CoverImage
      src={Image}
      alt="CoverImage"
      heading="Claim a free Game Pass token"
      desc="Hver dag kan 10 heldige brugere vinde 1 måned gratis Game Pass token med adgang til over 100 spil."
    />
  );
};

export default GamePassPage;
